//Styling
import "./App.css";
//Packages
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
//Components
import { PageContainer } from "./components/PageContainer/PageContainer";
import { Home } from "./pages/Home/Home";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PageContainer />}>
            <Route path=":language" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
